<template>
    <div>
        <section class="margin-two-top">
        <b-container>
          <b-row>
            <b-col
              cols="12"
              class="bg-white section__border-radius padding-all-fifty"
            >
              <p class="text-medium color-black font-weight-bold">
                Datos del cliente
              </p>
              <span>
                Ingresa el documento en el buscador para obtener
                información
              </span>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <section class="margin-two-top">
        <b-container>
          <b-row>
            <b-col cols="12">
              <h5 class="title__name text-large color-orange">
                Orden de Servicio - Detalle
              </h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="4"
              class="bg-white section__border-radius padding-all-twenty"
            >
              <b-button class="bg-transparent border-none">
                <font-awesome-icon icon="plus" class="color-orange" />
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </div>
</template>
<script>
export default {
    name:"DivGeneric"
}
</script>
<style scoped>

</style>